/**
 * Картинка, закрытая авторизацией (фото объявления: /board/photo/{id}).
 *
 * Обычный <img src="/board/photo/5"> не сработает: браузер, загружая картинку, не шлёт
 * заголовок Authorization — та же беда, что со ссылками на документы и квитанции.
 * Поэтому качаем байты сами (клиент подставит токен и при надобности продлит сессию),
 * а в <img> отдаём ссылку на blob.
 *
 * Blob-ссылку обязательно освобождать: браузер держит байты в памяти, пока её не отозвали.
 */

import { useEffect, useState } from 'react'

import { api } from '@/api/client'

export function useAuthImage(path: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (path === null) {
      setUrl(null)
      return
    }

    let revoked = false
    let created: string | null = null

    api
      .blobUrl(path)
      .then((objectUrl) => {
        // Компонент успели размонтировать, пока картинка качалась — сразу отпускаем.
        if (revoked) {
          URL.revokeObjectURL(objectUrl)
          return
        }
        created = objectUrl
        setUrl(objectUrl)
      })
      .catch(() => setUrl(null))

    return () => {
      revoked = true
      if (created !== null) URL.revokeObjectURL(created)
    }
  }, [path])

  return url
}
